import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast } from "../../../components/toast/Toasts";

export const tokenCheck = createAsyncThunk("UserLogin/TokenCheck", async () => {
  try {
    const response = await axiosApiInstance.get(
      `${API_URL}/UserLogin/TokenCheck`
    );
    return response.data?.Data;
  } catch (error: any) {
    console.error("Error Token Check:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const getDashBoardCount = createAsyncThunk(
  "Dashboard/DashBoardCount",
  async (filter: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/DashBoardCount`,
        filter
      );
      if (response.data.Status === 200) {
        return response?.data?.Data?.DashBoardCountList;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      console.error("Error Fetching InquirySubtype:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashBoardFollowups = createAsyncThunk(
  "Dashboard/Top5Followup",
  async (filter: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/Top5Followup`,
        filter
      );
      if (response.data.Status === 200) {
        return response?.data?.Data;
      } else {
        ErrorToast(response?.data?.Details || "Something went wrong");
        console.error(response?.data?.Details);
      }
    } catch (error: any) {
      console.error("Error Fetching InquirySubtype:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashboardBookings = createAsyncThunk(
  "Dashboard/DashBoardNextDeparture",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/DashBoardNextDeparture`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Tour Bookings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashboardFITBookings = createAsyncThunk(
  "Dashboard/DashBoardFITBooking",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/DashBoardFITBooking`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Tour Bookings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashboardQuotations = createAsyncThunk(
  "Dashboard/DashBoardQuotation",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/DashBoardQuotation`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Tour Bookings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashboardLeads = createAsyncThunk(
  "Dashboard/DashBoardLead",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/DashBoardLead`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Tour Bookings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashboardInquiriesOld = createAsyncThunk(
  "Dashboard/DashBoardInquiry",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/DashBoardInquiry`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Tour Bookings:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashboardInquiries = createAsyncThunk(
  "Dashboard/DashBoardInquiryCountData",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/DashBoardInquiryCountData`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching inquiries:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDashboardSeemoreFollowups = createAsyncThunk(
  "Dashboard/SeeMoreFollowupList",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/SeeMoreFollowupList`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Follow-ups:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const getDashboardSeemoreFollowupsChartWise = createAsyncThunk(
  "Dashboard/DashBoardTodaysFollowupORUpcomingANDreminderDAta",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dashboard/DashBoardTodaysFollowupORUpcomingANDreminderDAta`,
        payload
      );
      return response.data?.Data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Follow-ups:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
